<template>
    <div id="building">
        <v-card-subtitle class="font-weight-bold pb-0">
            <v-icon :color="subAppColor" left>mdi-home-group</v-icon> Building Preferences
        </v-card-subtitle>
        <v-card-text>
            <v-container fluid>
                <v-row>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="pa-0">
                            <v-icon :color="subAppColor" left>mdi-home-floor-1</v-icon>Building - First Choice
                        </v-card-subtitle>
                        <v-text-field v-model="item.buildingOption01" readonly label="Building Preference"
                            placeholder="Not available">
                        </v-text-field>
                        <v-text-field v-model="item.buildingUnit01" readonly label="Preferred Unit(s)"
                            placeholder="Not available">
                        </v-text-field>
                        <v-text-field v-model="item.buildingPartner01" readonly
                            label="Preferred Residence Assistant Parter(s)" placeholder="Not available">
                        </v-text-field>
                        <v-checkbox v-model="item.buildingContractCondition01" false-value="0"
                            label="I have read and agree to the contract conditions" readonly true-value="1">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="pa-0">
                            <v-icon :color="subAppColor" left>mdi-home-floor-2</v-icon>Building - Second Choice
                        </v-card-subtitle>
                        <v-text-field v-model="item.buildingOption02" readonly label="Building Preference"
                            placeholder="Not available">
                        </v-text-field>
                        <v-text-field v-model="item.buildingUnit02" readonly label="Preferred Unit(s)"
                            placeholder="Not available">
                        </v-text-field>
                        <v-text-field v-model="item.buildingPartner02" readonly
                            label="Preferred Residence Assistant Parter(s)" placeholder="Not available">
                        </v-text-field>
                        <v-checkbox v-model="item.buildingContractCondition02" false-value="0"
                            label="I have read and agree to the contract conditions" readonly true-value="1">
                        </v-checkbox>
                    </v-col>
                    <v-col cols="12" lg="6">
                        <v-card-subtitle class="pa-0">
                            <v-icon :color="subAppColor" left>mdi-home-floor-3</v-icon>Building - Third Choice
                        </v-card-subtitle>
                        <v-text-field v-model="item.buildingOption03" readonly label="Building Preference"
                            placeholder="Not available">
                        </v-text-field>
                        <v-text-field v-model="item.buildingUnit03" readonly label="Preferred Unit(s)"
                            placeholder="Not available">
                        </v-text-field>
                        <v-text-field v-model="item.buildingPartner03" readonly
                            label="Preferred Residence Assistant Parter(s)" placeholder="Not available">
                        </v-text-field>
                        <v-checkbox v-model="item.buildingContractCondition03" false-value="0"
                            label="I have read and agree to the contract conditions" readonly true-value="1">
                        </v-checkbox>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.buildingUnitPreference" readonly label="Unit Preference"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12" md="6">
                        <v-text-field v-model="item.residenceMealPlan" readonly label="Meal Plan"
                            placeholder="Not available">
                        </v-text-field>
                    </v-col>
                    <v-col cols="12">
                        <v-textarea v-model="item.healthDietaryConcern" auto-grow readonly hide-details
                            label="Health/Dietary Concern(s)" outlined placeholder="Not specified">
                        </v-textarea>
                    </v-col>
                </v-row>
            </v-container>
        </v-card-text>
    </div>
</template>

<script>
export default {
    name: 'ra-applicant-building-information',
    props: {
        item: {
            required: true,
            type: Object
        }
    },
    computed: {
        infoColor() {
            return '#5578eb';
        },
        subAppColor() {
            return '#FFA800';
        }
    }
}
</script>